module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "articleDetail"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("内容管理 > 查看详情\n\n\t\t"), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.articleForm.status == 2) ? _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toTop
    }
  }, [_vm._v("置顶")]) : _vm._e(), _vm._v(" "), (_vm.articleForm.status == 3) ? _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.noTop
    }
  }, [_vm._v("取消置顶")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.noIssue
    }
  }, [_vm._v("撤销发布")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goComment
    }
  }, [_vm._v("评论管理")])], 1), _vm._v(" "), _c('div', {
    staticClass: "articleNum"
  }, [_c('div', {
    staticClass: "readNum"
  }, [_vm._v("阅读：" + _vm._s(_vm.articleForm.readNum))]), _vm._v(" "), _c('div', {
    staticClass: "likeNum"
  }, [_vm._v("顶：" + _vm._s(_vm.articleForm.likeNum))]), _vm._v(" "), _c('div', {
    staticClass: "unlikeNum"
  }, [_vm._v("踩：" + _vm._s(_vm.articleForm.unlikeNum))])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('el-form', {
    ref: "articleForm",
    attrs: {
      "model": _vm.articleForm,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "封面图片"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "325px",
      "height": "125px"
    },
    attrs: {
      "src": _vm.articleForm.url,
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.articleForm.listImage) ? _c('el-form-item', {
    attrs: {
      "label": "列表图片"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "325px",
      "height": "125px"
    },
    attrs: {
      "src": _vm.articleForm.listImage,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticClass: "articleTitle",
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.articleForm.title),
      callback: function($$v) {
        _vm.$set(_vm.articleForm, "title", $$v)
      },
      expression: "articleForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "articleAbstract",
    attrs: {
      "label": "摘要"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 5
      },
      "disabled": ""
    },
    model: {
      value: (_vm.articleForm.abstract),
      callback: function($$v) {
        _vm.$set(_vm.articleForm, "abstract", $$v)
      },
      expression: "articleForm.abstract"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "articleAuthor",
    attrs: {
      "label": "初始阅读数",
      "prop": "initReadCount"
    }
  }, [_c('el-input', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.articleForm.initReadCount),
      callback: function($$v) {
        _vm.$set(_vm.articleForm, "initReadCount", $$v)
      },
      expression: "articleForm.initReadCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "articleAuthor",
    attrs: {
      "label": "初始点赞数",
      "prop": "initLikeCount"
    }
  }, [_c('el-input', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.articleForm.initLikeCount),
      callback: function($$v) {
        _vm.$set(_vm.articleForm, "initLikeCount", $$v)
      },
      expression: "articleForm.initLikeCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "articleAuthor",
    attrs: {
      "label": "作者"
    }
  }, [_c('el-input', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.articleForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.articleForm, "phone", $$v)
      },
      expression: "articleForm.phone"
    }
  }), _vm._v(_vm._s(_vm.articleForm.authorInfo) + "\n\t\t\t")], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "articleType",
    attrs: {
      "label": "类别"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.articleForm.type),
      callback: function($$v) {
        _vm.$set(_vm.articleForm, "type", $$v)
      },
      expression: "articleForm.type"
    }
  })], 1), _vm._v(" "), _c('select-school', {
    attrs: {
      "schObj": _vm.articleForm.schObj,
      "canUse": _vm.canUse
    }
  }), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    staticClass: "radio",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.articleForm.ifNotice),
      callback: function($$v) {
        _vm.$set(_vm.articleForm, "ifNotice", $$v)
      },
      expression: "articleForm.ifNotice"
    }
  }, [_vm._v("首次发布，向所有用户发送更新通知")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "articleContent",
    attrs: {
      "label": "内容"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 20
      },
      "disabled": ""
    },
    model: {
      value: (_vm.articleForm.content),
      callback: function($$v) {
        _vm.$set(_vm.articleForm, "content", $$v)
      },
      expression: "articleForm.content"
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64cdf139!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/article/articleDetail.vue
// module id = 1052
// module chunks = 0